import React, { createContext, useContext, useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import { Logger } from 'services/logger';

import { DEFAULT_LOCALE, SEARCH_ENABLED_LOCALES, getLangCodeFromLocale } from 'utils/localisationConfig';

const LocaleContext = createContext(null);

const defaultLocalisation = {
  locale: DEFAULT_LOCALE,
  langCode: getLangCodeFromLocale(DEFAULT_LOCALE),
};

export const LocaleProvider = ({ children, localisation = defaultLocalisation, availableLocalisations = [] }) => {
  const { i18n } = useTranslation();
  const locale = localisation?.locale;
  const isSearchEnabled = SEARCH_ENABLED_LOCALES.includes(locale);

  useEffect(() => {
    if (locale && i18n.language !== locale) {
      void i18n.changeLanguage(locale);
    }
  }, [locale, i18n]);

  return (
    <LocaleContext.Provider
      value={{
        localisation,
        availableLocalisations,
        isSearchEnabled,
      }}
    >
      {children}
    </LocaleContext.Provider>
  );
};

export const useLocale = () => {
  const context = useContext(LocaleContext);

  if (!context) {
    Logger.error('useLocale must be inside LocaleProvider');
    return {};
  }

  return context;
};
